import { CycleUtils } from '@wix/package-picker-shared';
import { CycleSelector as PlatformCycleSelector } from '@wix/premium-purchase-platform/@components';
import { useCurrentModule } from '@wix/package-picker-shared-eclipse';
import React from 'react';

import { EclipsePackagePickerModule } from '../../modules/eclipse-package-picker.module';
import { CycleSelectorItem } from './CycleSelectorItem';
import { getCycleListMaxWidth } from './cycleListWidth';

export const CycleSelector = () => {
  const selectedProductId =
    EclipsePackagePickerModule.SDK.PackagePickerStore.useSelectedProductId();
  const { isQuickPayLightbox } = useCurrentModule().internals.useContext();

  if (!selectedProductId) {
    // Should not get to here because of RouteGuard
    return null;
  }

  return (
    <PlatformCycleSelector.Root
      productId={selectedProductId}
      gap="SP2"
      width="100%"
      maxWidth={getCycleListMaxWidth(isQuickPayLightbox)}
    >
      {(pricingDetails) => {
        return pricingDetails.map((pricingDetail) => {
          const { cycle } = pricingDetail;

          if (!cycle) {
            return null;
          }

          return (
            <CycleSelectorItem
              key={CycleUtils.convertCycleToCycleId(cycle)}
              cycleId={CycleUtils.convertCycleToCycleId(cycle)}
              productId={selectedProductId}
            />
          );
        });
      }}
    </PlatformCycleSelector.Root>
  );
};
